export enum EDeliveryRequestStatus {
  UNKNOWN = "UNKNOWN",
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}
